import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Contatti } from 'my-lib-sanfelici/my-lib-sanfelici';
import { ContattiService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-contatti-list',
  templateUrl: './contatti-list.component.html',
  styleUrls: ['./contatti-list.component.css']
})
export class ContattiListComponent implements OnInit {
contatti: Observable<Contatti[]>;

  constructor(private contattiservice: ContattiService) { }

  ngOnInit() {
this.contatti = this.contattiservice.list();
  }

}
